import React from 'react'

export const FormField = ({
  title,
  value,
  className,
  component,
  disabled = false,
  ...otherProps
}) => {
  return (
    <div className={['FormField', className].filter((f) => !!f).join(' ')}>
      <div className='title'>{title}</div>
      {disabled ? (
        <div className='value'>{value}</div>
      ) : (
        component || <div className='value'>{value}</div>
      )}
    </div>
  )
}

export default FormField
